import { Disclosure } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import Link from "next/link";
import { twMerge } from "tailwind-merge";

type DisclosureItem = {
  name: string;
  href: string;
  label: string;
};

type PopoverDisclosureProps = {
  name: string;
  items: DisclosureItem[];
  label: string;
  callback?: () => void;
};
export const PopoverDisclosure = ({
  name,
  items,
  label,
  callback,
}: PopoverDisclosureProps) => (
  <Disclosure as="div" defaultOpen>
    {({ open }) => (
      <>
        <Disclosure.Button
          className="flex w-full px-4 py-2 text-sm text-gray-700"
          aria-label={`open ${label} pages`}
        >
          {name}
          <ChevronRightIcon
            className={twMerge(
              open ? "rotate-90 text-gray-500" : "text-gray-400",
              "h-5 w-5 shrink-0"
            )}
            aria-hidden="true"
          />
        </Disclosure.Button>

        <Disclosure.Panel
          as="ul"
          className="mt-1"
          aria-label={`${label} links`}
        >
          {items.map((subItem) => (
            <li key={subItem.name}>
              <Link
                href={subItem.href}
                className={twMerge(
                  "block px-4 py-2 pl-9 text-sm text-zinc-500 hover:bg-gray-100"
                )}
                aria-label={subItem.label}
                onClick={callback}
                prefetch
              >
                {subItem.name}
              </Link>
            </li>
          ))}
        </Disclosure.Panel>
      </>
    )}
  </Disclosure>
);
